export const tableHeadersData = [
    {
      header: "fechaalta",
      title: "Fecha Alta",
      type: "datetime",
      footerDataType: "count",
    },
    { header: "idespecialidad_desc", title: "Especialidad", type: "string" },
    { header: "documento", title: "Documento paciente", type: "integer" },
    { header: "idpaciente_desc", title: "Paciente", type: "string" },
    {
      header: "importe",
      title: "Importe",
      type: "currency",
      footerDataType: "sum",
    },
  ];